import { Component, Inject } from '@angular/core';
import { MotorVehiclesToReplace } from '@app/salesfunnel/interfaces';
import {
    NewModalRef as ModalRef,
    NEW_MODAL_DATA as MODAL_DATA
} from 'outshared-lib';

export interface BonusMalusModalData {
    data: MotorVehiclesToReplace;
}

@Component({
    selector: 'ins-bonus-malus-modal',
    templateUrl: './bonus-malus-modal.component.html',
    styleUrls: [ './bonus-malus-modal.component.scss' ]
})
export class BonusMalusModalComponent {

    constructor(
        private modalRef: ModalRef<BonusMalusModalComponent>,
        @Inject(MODAL_DATA) public modalData: MotorVehiclesToReplace
    ) {}

    public close(): void {
        this.modalRef.close();
    }
}
